import { Select } from "antd";
import { Form } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import useCoreApi from "../../hooks/useCoreApi";

const RoleSelect = ({
  initialValue = null,
  readOnly = false,
  onChange = null,
  required = false,
  showSearch = false,
  validationMessage = "",
  selectedKey = null,
}) => {
  const { t } = useTranslation();

  // Load partners who are partner_ids_service_provider(s) (workers)
  // and output of this select is a invoice publisher ()

  const { loading, response } = useCoreApi("get", "/roles");

  return (
    <React.Fragment>
      <Form.Item
        name={"role"}
        label={t("roles.selectRole")}
        valuePropName={"value"}
        wrapperCol={24}
        initialValue={initialValue}
        rules={[
          {
            required: required,
            message: validationMessage,
          },
        ]}
        style={{ width: "100%" }}
      >
        <Select
          key={selectedKey}
          loading={loading}
          allowClear
          showSearch={showSearch}
          filterOption={
            showSearch ? (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 : null
          }
          onChange={(e) => {
            onChange && onChange(response.find((item) => item.name === e));
          }}
          disabled={readOnly}
          bordered={!readOnly}
          placeholder={t("roles.selectRole")}
        >
          {response?.map((item, i) => (
            <Select.Option key={i} value={item?.name}>
              {t("roles." + item?.name)}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </React.Fragment>
  );
};

export default RoleSelect;
